/** Processing outcomes are distinct from instruction execution status. */
export const assignmentOutcomeLabel = (outcome) => ({
  matched: 'Matched', partially_matched: 'Partly matched', unresolved: 'No match',
  creation_fallback: 'Creation fallback', intentional_placeholder: 'Intentional placeholder',
  preserved: 'Existing selection retained', not_applicable: 'Not applicable', mixed: 'Mixed outcomes',
}[outcome] || outcome || '');
